import React from 'react';
import { Button, Icon } from '@kajabi/sage-react';
import { MessageDataType } from 'common/components/CopyMagic/CopyMagic.types';
import useMessageRequestBehavior from 'common/components/CopyMagic/hooks/useMessageRequestBehavior/useMessageRequestBehavior';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';

import './style.scss';

type Props = {
  promptData: { user: MessageDataType; system: MessageDataType };
};

const PromptSuggestionsItem = ({ promptData }: Props) => {
  const { requestAndSetNewMessages } = useMessageRequestBehavior();
  const trackSuggestionClicked = useGeneratorTrackingCallback('useTrackSuggestionClicked');

  const handleClick = () => {
    trackSuggestionClicked({
      suggestion: promptData.user.content,
      systemMessage: promptData.system.content,
    });
    requestAndSetNewMessages([promptData.system, promptData.user]);
  };

  return (
    <>
      <Button
        color="secondary"
        customContentClassName="prompt-suggestions-item"
        hasCustomContent
        onClick={handleClick}
        subtle
      >
        <>
          <Icon
            cardColor={Icon.CARD_COLORS.LOCKED}
            color={Icon.COLORS.PURPLE_100}
            size={Icon.SIZES.MD}
            backgroundHeight="26px"
            backgroundWidth="26px"
            icon="stars-tone"
          />
          {promptData.user.content}
        </>
      </Button>
    </>
  );
};

export default PromptSuggestionsItem;
